import { Box, Image, Theme, Typography } from "@outschool/backpack";
import { TrackedButton } from "@outschool/ui-components-shared";
import { useLinkComponent } from "@outschool/ui-utils";
import React from "react";
import { LinkGridProps, LinkGridPropsItem } from "./types";

export default function CircleLinkGrid({
  title,
  items,
  renderImage,
}: LinkGridProps) {
  const Link = useLinkComponent();

  return (
    <Box
      flex
      sx={{
        backgroundColor: "transparent",
        alignItems: "center",
        flexDirection: "column",
        paddingY: "2em",
      }}
    >
      <Typography align="center" variant="h3">
        {title}
      </Typography>

      <Box
        sx={(theme: Theme) => ({
          display: "grid",
          gridTemplateColumns: "repeat(2, 1fr)",

          [theme.breakpoints.up("md")]: {
            gridTemplateColumns: "repeat(auto-fit, minmax(220px, 1fr))",
            justifyItems: "start",
          },

          gap: "30px 15px",
          justifyItems: "center",
          width: "calc(100% - 64px)",
          maxWidth: "1024px",
          paddingY: "30px",
        })}
      >
        {items.map((item: LinkGridPropsItem, index: number) => (
          <TrackedButton
            key={index + item.path}
            variant="link"
            size="inherit"
            trackingName="home_page_topic_grid"
            trackingUniqueId={item.text}
            component={Link}
            to={item.path}
            sx={(theme: Theme) => ({
              padding: 0,
              display: "grid",
              alignItems: "center",
              justifyItems: "center",
              [theme.breakpoints.up("md")]: {
                display: "flex",
                justifyItems: "start",
              },
              border: "none !important",
              background: "transarent",
            })}
          >
            <Box
              sx={(theme: Theme) => ({
                display: "block",
                width: "88px",
                height: "88px",
                background: "white",
                boxShadow: "0 2px 10px rgba(0, 0, 0, 0.25)",
                borderRadius: "100%",
                marginRight: "12px",

                [theme.breakpoints.up("md")]: {
                  marginRight: "12px",
                  marginBottom: "0",
                },

                marginBottom: "12px",
              })}
            >
              {renderImage ? (
                renderImage(
                  {
                    alt: item.imageAltText,
                    src: item.image.url,
                    width: "84px",
                    height: "84px",
                  },
                  {
                    objectFit: "contain",
                  }
                )
              ) : (
                <Image
                  alt={item.imageAltText}
                  src={item.image.url}
                  sx={{
                    height: "100%",
                    width: "100%",
                    padding: "10px",
                  }}
                />
              )}
            </Box>
            <Typography
              variant="h6"
              sx={{
                color: "grey.900",
                textAlign: "left",
              }}
            >
              {item.text}
            </Typography>
          </TrackedButton>
        ))}
      </Box>
    </Box>
  );
}
